import React from 'react';
import '../../App.css';
//import Cards from '../Cards';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import Mission from '../Mission';
import Contact from '../Contact'
import CDKSeries from '../CDKSeries';
import Book from '../Book';
import History from '../History'

function Home() {
  return (
    <>
      <HeroSection />
      <Mission />
      <CDKSeries />
      <History />
      <Book />
      <Contact />
      <Footer />
    </>
  );
}

export default Home;
